import styled from 'styled-components';

export const CoursesLayoutWrapper = styled.div`
  --courseSectionPriceHeight: 70px;
  @media (min-width: 768px) {
    height: 550px;
    display: grid;
    grid-template-columns: 220px auto;
    border-radius: var(--pricingCardRadius);
    border: 1px solid var(--greyBorderColor);
    overflow: hidden;
  }
  @media (min-width: 1400px) {
    height: calc(100vh - 70px);
    grid-template-columns: 270px auto;
  }
  @media (min-width: 1600px) {
    grid-template-columns: 300px auto;
  }
  @media (min-width: 1800px) {
    grid-template-columns: 330px auto;
  }
`;

// select container
export const CourseGroupSelectWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  position: relative;
  border-radius: 4px;
  color: var(--inputTxtColor);
  background-color: #fff;
  border: 1px solid var(--greyBorderColor);
  cursor: pointer;
  margin-top: ${(props) => props.secondarySelection && '16px'};
  @media (min-width: 576px) {
    margin-top: ${(props) => props.secondarySelection && 'unset'};
    margin-left: ${(props) => props.secondarySelection && '16px'};
  }
`;

export const NavWrapper = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    width: 100%;
    padding: 20px 0px var(--courseSectionPriceHeight) 0px;
    overflow: hidden;
    background-color: #fff;
    border-right: 1px solid var(--greyBorderColor);
  }
`;

export const NavHead = styled.h4`
  color: var(--inputTxtColor);
  height: 38px;
  padding-inline: 16px;
  padding-bottom: 0px;
  border-bottom: 1px solid var(--greyShadowColor);
  @media (min-width: 1400px) {
    padding-inline: 20px;
  }
  @media (min-width: 1800px) {
    padding-inline: 24px;
    font-size: 18px !important;
  }
`;

export const NavBtnsWrapper = styled.div`
  height: calc(100% - 38px);
  padding: 12px 8px;
  overflow-y: auto;
  @media (min-width: 1400px) {
    padding: 12px 12px;
  }
  @media (min-width: 1800px) {
    padding: 12px 16px;
  }
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: #d2e3ff;
  }
`;

export const NavBtn = styled.div`
  padding: 4px 8px 4px 30px;
  margin-bottom: 4px;
  position: relative;
  cursor: pointer;
  color: ${({ navActive }) => (navActive ? 'var(--inputTxtColor)' : 'var(--normalTxtColor)')};
  &:hover {
    color: ${({ navActive }) => !navActive && 'var(--secondary)'};
  }
`;

export const NavTitle = styled.p`
  font-family: var(--headingFont);
  font-size: ${(props) => (props.navActive ? '15px' : '14px')};
  line-height: ${({ variant }) => !variant === 'regionals' && 'normal'};
  text-transform: capitalize;
  @media (min-width: 1800px) {
    font-size: ${(props) => (props.navActive ? '16px' : '15px')};
  }
`;

export const NavCheckbox = styled.input`
  position: absolute;
  height: 15px;
  width: 15px;
  top: 7px;
  left: 8px;
  accent-color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsDark)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'} !important;
  pointer-events: none;
  transition: 0.1s;
`;

export const CoursesResultWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  @media (min-width: 768px) {
    padding-bottom: var(--courseSectionPriceHeight);
  }
`;

export const CoursesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  justify-content: center;
  @media (min-width: 576px) {
    grid-template-columns: repeat(2, 48%);
    justify-content: space-between;
  }
  @media (min-width: 768px) {
    max-height: 100%;
    padding: 10px 24px;
    overflow-y: auto;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 31%);
  }
  @media (min-width: 1400px) {
    padding: 16px 32px;
  }
  &::-webkit-scrollbar {
    width: 5px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: #d2e3ff;
  }
`;

export const NewCourseDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 15px auto;
  padding: ${(props) => (props.isFree || (props.isOffer && props.country === 'IN') ? '35px 0px 0px 0px' : '0px')};
  width: 100%;
  max-width: 320px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: ${(props) => (props.forSkeleton ? '0px 3px 9px var(--greyShadowColor)' : '0px 2px 12px var(--greyShadowColor)')};
  @media (min-width: 576px) {
    max-width: unset;
  }
`;

export const CourseTitle = styled.p`
  text-align: left;
  padding-bottom: 10px;
  color: var(--dark);
  font-size: 15px;
  font-weight: 500;
  font-family: var(--headingFont);
  @media (min-width: 1800px) {
    font-size: 16px;
  }
`;

export const CourseBottomDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding-top: 10px;
  @media (min-width: 481px) {
    align-items: ${({ isFree }) => isFree && 'start'};
  }
`;

export const CoursePriceDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1600px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const CourseListPrice = styled.del`
  color: var(--secondary);
  font-family: var(--headingFont);
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 1;
  @media (min-width: 900px) {
    font-size: 15px;
  }
  @media (min-width: 1400px) {
    font-size: 16px;
  }
  @media (min-width: 1600px) {
    margin-bottom: unset;
    margin-right: 8px;
  }
`;

export const CourseOfferPrice = styled.span`
  color: var(--dark);
  font-family: var(--headingFont);
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  @media (min-width: 900px) {
    font-size: 20px;
  }
`;

export const CourseBuyButtonWrapper = styled.div`
  width: 100px;
  height: 34px;
`;

export const CoursePricingBar = styled.div`
  position: relative;
  width: 100%;
  max-width: 320px;
  padding: 10px 16px;
  margin: 12px auto 0px;
  border-radius: var(--pricingCardRadius);
  border: 1px solid var(--greyShadowColor);
  overflow: hidden;
  cursor: pointer;
  z-index: 0;
  font-size: 15px;
  color: #fff;
  // background: ${({ variant }) => (variant === 'partner-plus' ? '#deffeb' : variant === 'regionals' ? '#fbd4ff' : variant === 'code-juniors' ? '#fdf6f4' : '#f1f4fb')};
  background: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ variant }) =>
      variant === 'partner-plus'
        ? 'var(--stripedPartnerBg)'
        : variant === 'regionals'
        ? 'var(--stripedRegionalsBg)'
        : variant === 'code-juniors'
        ? 'var(--stripedJuniorsBg)'
        : 'var(--stripedBlueBg)'};
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
  @media (min-width: 481px) {
    max-width: unset;
    font-size: 16px;
  }
  @media (min-width: 768px) {
    position: absolute;
    bottom: 0px;
    height: var(--courseSectionPriceHeight);
    padding: 0px 24px;
    margin: unset;
    border-radius: unset;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
